// extracted by mini-css-extract-plugin
export default {"Button":"DisclosureButton_Button__zzm5p","MainText":"DisclosureButton_MainText__aBRJ+"};